import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-black border-b border-yellow-500/50 py-1.5 px-3 shadow-lg" data-id="element-97">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-2" data-id="element-98">
        <div className="flex items-center gap-1.5" data-id="element-99">
          <span className="animate-pulse h-2 w-2 rounded-full bg-red-500 shrink-0" data-id="element-100"></span>
          <p className="text-white font-bold text-[11px] sm:text-xs uppercase tracking-wide" data-id="element-101">
            <span className="text-yellow-400" data-id="element-102">OFERTA LIMITADA</span>
            <span className="hidden sm:inline" data-id="element-103"> · Solo quedan 7 copias</span>
          </p>
        </div>
        <div className="flex items-center gap-2" data-id="element-104">
          <span className="text-gray-400 text-[10px] uppercase font-semibold hidden sm:inline" data-id="element-105">
            Expira en:
          </span>
          <CountdownTimer data-id="element-106" />
        </div>
      </div>
    </div>;
}